export const PLAN = "plan"
export const GIFT = "gift"
export const PRODUCT = "product"
export const DISCOUNT = "discount"
export const SHIPPING = "shipping"
